import AparênciaPadrão from './Store/AparênciaPadrão'
import { mobile } from '@Shared/Device'

let webMessengerToken = null
let replies = {}

window.addEventListener('load', async () => {
    let script = document.querySelector('#teclia-web-messenger')
    let endpoint = script.getAttribute('endpoint')
    let staticEndpoint = script.getAttribute('static-endpoint')
    webMessengerToken = script.getAttribute('web-messenger-token')

    let webMessenger = await carregarWebMessenger(staticEndpoint || endpoint, webMessengerToken)

    let iframe = document.createElement('iframe')
    iframe.setAttribute('allow', 'camera;microphone')

    let iframeSrc = (staticEndpoint || endpoint) + '/api/chat/web_messengers.html'

    if (location.href.indexOf('longpoll') !== -1) {
        iframeSrc += '?longpoll'
    }

    iframe.src = iframeSrc

    iframe.setAttribute('style', styleDoIframe(script, webMessenger))
    iframe.onload = boot(iframe, script, webMessenger, webMessengerToken)

    document.body.appendChild(iframe)
})

function boot(iframe, script, webMessenger, webMessengerToken) {
    registrarEventosDoIframe(script, iframe)

    window.addEventListener('focus', () => {
        iframe.contentWindow.postMessage({ type: 'window-focus' }, '*')
    })

    window.addEventListener('blur', () => {
        iframe.contentWindow.postMessage({ type: 'window-blur' }, '*')
    })

    return () => {
        // Tentar carregar estado e passar nos parâmetros do boot também.
        let dados = null
        let state = {}

        try {
            if (typeof window.localStorage !== 'undefined') {
                console.log('Reading from localStorage')
                dados = localStorage.getItem('teclia_widget_state_' + webMessengerToken)
            }
            state = JSON.parse(dados)
        } catch (err) {}

        let parsedProfile = null

        if (script.hasAttribute('data-merge-profile')) {
            try {
                parsedProfile = JSON.parse(script.getAttribute('data-merge-profile'))
            } catch (err) {
                console.warn('Could not parse profile from script tag', err)
            }
        }

        iframe.contentWindow.postMessage(
            {
                type: 'boot',
                boot: {
                    ...webMessenger,
                    width: window.innerWidth,
                    webMessengerToken,
                    state,
                    profile: parsedProfile,
                    maxAmountOfActiveRooms: script.getAttribute('data-max-amount-of-active-rooms'),
                    startChatRoom: script.getAttribute('data-start-chat-room'),
                    onlyAllowNewChatRoomsFromAPICalls:
                        script.getAttribute('data-only-allow-new-chat-rooms-from-api-calls') == 'true',
                    fullscreen: script.getAttribute('fullscreen') == 'true',
                    maxActiveTicketsPerGroup: script.getAttribute('data-max-active-tickets-per-group'),
                    groupTicketsBy: script.getAttribute('data-group-tickets-by'),
                    firstMessage: script.getAttribute('data-first-message'),
                    forceInviteOnLoad: mobile() && !script.getAttribute('fullscreen'),
                },
            },
            '*'
        )

        /**
         * Expor a API pública do Teclia.
         */
        // window.Teclia = iframe.contentWindow.Teclia
        window.Teclia = {
            getProfile() {
                let reply = new Date().getTime()
                iframe.contentWindow.postMessage({ type: 'invoke', invoke: 'getProfile', arguments: null, reply }, '*')
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(replies[reply])
                    }, 500)
                })
            },

            getActiveRoomsCount() {
                let reply = new Date().getTime()
                iframe.contentWindow.postMessage(
                    { type: 'invoke', invoke: 'getActiveRoomsCount', arguments: null, reply },
                    '*'
                )
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(replies[reply])
                    }, 500)
                })
            },

            mergeProfile(profile) {
                iframe.contentWindow.postMessage({ type: 'invoke', invoke: 'mergeProfile', arguments: [profile] }, '*')
            },

            hideInvite() {
                iframe.contentWindow.postMessage({ type: 'invoke', invoke: 'hideInvite', arguments: [] }, '*')
            },

            showInvite() {
                iframe.contentWindow.postMessage({ type: 'invoke', invoke: 'showInvite', arguments: [] }, '*')
            },

            open() {
                iframe.contentWindow.postMessage({ type: 'invoke', invoke: 'open', arguments: [] }, '*')
            },

            setMaxAmountOfActiveRooms(n) {
                iframe.contentWindow.postMessage(
                    { type: 'invoke', invoke: 'setMaxAmountOfActiveRooms', arguments: [n] },
                    '*'
                )
            },

            startChatRoom(text) {
                iframe.contentWindow.postMessage({ type: 'invoke', invoke: 'startChatRoom', arguments: [text] }, '*')
            },

            onlyAllowNewChatRoomsFromAPICalls() {
                iframe.contentWindow.postMessage(
                    { type: 'invoke', invoke: 'onlyAllowNewChatRoomsFromAPICalls', arguments: [] },
                    '*'
                )
            },
        }

        console.log('dispatch: `teclia:web-messenger-load`')
        document.dispatchEvent(new CustomEvent('teclia:web-messenger-load'))
    }
}

function styleDoIframe(script, { appearance }) {
    if (!appearance) appearance = AparênciaPadrão

    if (fullscreen(script)) {
        return `position: absolute; top: 0; left: 0; width: 100%; height: 100%;`
    }

    let yAxis = `bottom: ${appearance.inviteBottomMargin}px; margin-top: ${appearance.inviteBottomMargin}px; max-height: 650px;`

    if (appearance.position == 'bottom-left') {
        return `z-index: 9999999; border: none; position: fixed; ${yAxis}; left: ${appearance.inviteSideMargin}px; width: 0px; height: 0px;`
    } else {
        return `z-index: 9999999; border: none; position: fixed; ${yAxis}; right: ${appearance.inviteSideMargin}px; width: 0px; height: 0px;`
    }
}

function registrarEventosDoIframe(script, iframe) {
    window.addEventListener('message', message => {
        if (!message.data) return

        switch (message.data.type) {
            case 'resize':
                if (fullscreen(script)) return

                iframe.style.width = message.data.width
                iframe.style.height = message.data.height

                if (message.data.shadow) {
                    iframe.style.borderRadius = '8px'
                    iframe.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                } else {
                    iframe.style.borderRadius = '0'
                    iframe.style.boxShadow = 'none'
                }

                break

            case 'salvarEstado':
                try {
                    if (typeof window.localStorage !== 'undefined') {
                        localStorage.setItem(
                            'teclia_widget_state_' + webMessengerToken,
                            JSON.stringify(message.data.dados)
                        )
                    }
                } catch (err) {}
                break

            case 'reply':
                replies[message.data.reply] = message.data.result
        }
    })
}

async function carregarWebMessenger(endpoint, webMessengerToken) {
    const sendRequest = url => {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest()
            xhr.onreadystatechange = () => {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        resolve(JSON.parse(xhr.responseText))
                    } else {
                        reject({ status: xhr.status, response: xhr.responseText })
                    }
                }
            }
            xhr.open('GET', url)
            xhr.send()
        })
    }

    try {
        return await sendRequest(
            endpoint + '/web_messenger_appearance/' + webMessengerToken + '.json?time=' + new Date().getTime()
        )
    } catch (err) {
        return await sendRequest(endpoint + '/api/chat/web_messengers/' + webMessengerToken + '.json')
    }
}

function fullscreen(script) {
    return script.getAttribute('fullscreen') == 'true'
}
